export default __webpack_public_path__ + "static/media/B0001.26fdeb31.png";